module.exports = __webpack_public_path__ + "static/media/down.9d36129a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/down.svg
// module id = 270
// module chunks = 0